<div fxLayout="column" fxFlex="100%">
  <div fxLayout="row" fxFlex="80%">
      <dx-list
        #commentlist
        class="comments-list"
        [dataSource]="comments"
        [allowItemDeleting]="true"
        [focusStateEnabled]="false"
        [noDataText]="dataService.res('Comments-Library-NoComments')"
        [searchEnabled]="true"
        [width]="100+'%'"
        [height]="100+'%'"
        searchExpr="Text"
        [itemDeleteMode]="deleteMode"
        (onItemClick)="updateComment($event)"
        (onItemDeleted)="deleteComment($event)"
      >    
        <dxo-search-editor-options [placeholder]="dataService.res('Comments-Library-Placeholder')" >
        </dxo-search-editor-options>
          <div *dxTemplate="let item of 'item'" style="cursor: default;">
            <img
                style="float: left; height: 20px; width: 20px"
                class="image-container"
                src="assets/images/User-white-background.svg"
            />
            <div class="fullname">{{ item.SysUserNameInsert }}</div>
            <div class="date">
              &nbsp;{{ item.SysDateInsert | date: 'dd.MM.yyyy' }}
              &nbsp;{{ item.SysTimeInsert | date: 'HH:mm:ss' }}
            </div>
            <div class="message-box">
              {{ item.Text }}
            </div>
          </div>
      </dx-list>
  </div>
  <div class="comment-class" fxLayout="row" fxFlex="20%">
    <abc-text-area
      #commentTextArea
      class="comment-textarea sideBySide"
      [(value)]="commentText"
      [placeholder]="dataService.res('Comments-Library-Comment')"
      [autoResizeEnabled]="true"
      [width]="'90%'"
      [minHeight]="45"
      [maxHeight]="75"
      [maxLength]="250"
    >
    </abc-text-area>
    <img src="assets/images/send-message.png" class="addCommentButton" style="cursor: pointer" (click)="addComment()" />
  </div>
</div>
